export default __webpack_public_path__ + "static/media/DE2.67457d03.svg";